import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { decode } from 'js-base64';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const httpRequest = async <T>(
  options: AxiosRequestConfig,
): Promise<AxiosResponse<T>> => {
  return await client(options);
};

export const addAuthInterceptor = (token: string): void => {
  client.defaults.headers.common = {
    Authorization: `Bearer ${decode(token)}`,
  };
};

export const removeAuthInterceptor = (): void => {
  delete client.defaults.headers.common['Authorization'];
};

export default httpRequest;
